module.exports = __webpack_public_path__ + "img/ho.f9e0809e.png";